import { apiRequest } from "@/api";
import { ENDPOINTS } from "@/api/endpoints";
import type { IProvider } from "./providers.types";

export async function fetchTrafficProviders(): Promise<IProvider[]> {
  const [data, error] = await apiRequest<IProvider[]>({
    method: "GET",
    path: ENDPOINTS.getTrafficProviderName,
    queries: { state: "enabled" },
  });
  if (error) throw new Error(error);
  return data ?? [];
}
